import { render, staticRenderFns } from "./ReportDocumentSignRequestDialog.vue?vue&type=template&id=3d97c16a&"
import script from "./ReportDocumentSignRequestDialog.vue?vue&type=script&lang=ts&"
export * from "./ReportDocumentSignRequestDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports